import projectDataMessages from './messages';
import sharedMessages from '../shared-messages';
import {MessageObject, TranslatorFunction} from '../../gui-config';

const messages = {...projectDataMessages, ...sharedMessages};

// use the default message if a translation function is not passed
const defaultTranslator = (msgObj: MessageObject) => msgObj.defaultMessage;

/**
 * Generate a localized version of the default project
 * @param {function} translateFunction a function to use for translating the default names
 * @returns {object} the project data json for the default project
 */
const projectData = (translateFunction?: TranslatorFunction): object => {
    const translator = translateFunction || defaultTranslator;
    return ({
        targets: [
            {
                isStage: true,
                name: 'Stage',
                variables: {
                    '`jEk@4|i[#Fk?(8x)AV.-my variable': [
                        translator(messages.variable),
                        0
                    ]
                },
                lists: {},
                broadcasts: {},
                blocks: {},
                currentCostume: 0,
                costumes: [
                    {
                        assetId: 'a9ab7960e5cad6caa8315bd0cfeb1038',
                        name: translator(messages.backdrop, {index: 1}),
                        md5ext: 'a9ab7960e5cad6caa8315bd0cfeb1038.png',
                        dataFormat: 'png',
                        bitmapResolution: 2,
                        rotationCenterX: 480,
                        rotationCenterY: 360
                    }
                ],
                sounds: [
                    {
                        assetId: '83a9787d4cb6f3b7632b4ddfebf74367',
                        name: translator(messages.pop),
                        dataFormat: 'wav',
                        format: '',
                        rate: 11025,
                        sampleCount: 258,
                        md5ext: '83a9787d4cb6f3b7632b4ddfebf74367.wav'
                    }
                ],
                volume: 100
            },
            {
                isStage: false,
                name: 'Mr Hien',
                variables: {},
                lists: {},
                broadcasts: {},
                blocks: {
                    'e584j?h$!clIad4mBE7{': {
                        opcode: 'looks_sayforsecs',
                        next: 'P:z0EWXP,l}Ao]PvZmVz',
                        parent: 'RTP9jg7#y!9N?XpfL4x]',
                        inputs: {MESSAGE: [1, [10, 'Xin chào các em!']], SECS: [1, [4, '2']]},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    '7)fBt`KwJm:XZe*$6@UQ': {
                        opcode: 'event_whenflagclicked',
                        next: '=Pn,ixLmJ5=8n{?U1uja',
                        parent: null,
                        inputs: {},
                        fields: {},
                        shadow: false,
                        topLevel: true,
                        x: 420,
                        y: 217
                    },
                    '03[9;CHse_kof}!{mBE!': {
                        opcode: 'looks_sayforsecs',
                        next: '^!Sf-X#B:1*C(!5foAq?',
                        parent: 'P:z0EWXP,l}Ao]PvZmVz',
                        inputs: {MESSAGE: [1, [10, 'Chào mừng các em đến với khóa học Scratch!']], SECS: [1, [4, '3']]},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    '=Pn,ixLmJ5=8n{?U1uja': {
                        opcode: 'looks_switchcostumeto',
                        next: 'os8-l8AuAr-4e2dpB`f:',
                        parent: '7)fBt`KwJm:XZe*$6@UQ',
                        inputs: {COSTUME: [1, '*z9i-(dmK1OS5[1KSE8c']},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    '*z9i-(dmK1OS5[1KSE8c': {
                        opcode: 'looks_costume',
                        next: null,
                        parent: '=Pn,ixLmJ5=8n{?U1uja',
                        inputs: {},
                        fields: {COSTUME: ['Mr Hien 0', null]},
                        shadow: true,
                        topLevel: false
                    },
                    'os8-l8AuAr-4e2dpB`f:': {
                        opcode: 'control_wait',
                        next: 'RTP9jg7#y!9N?XpfL4x]',
                        parent: '=Pn,ixLmJ5=8n{?U1uja',
                        inputs: {DURATION: [1, [5, '1']]},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    'RTP9jg7#y!9N?XpfL4x]': {
                        opcode: 'looks_switchcostumeto',
                        next: 'e584j?h$!clIad4mBE7{',
                        parent: 'os8-l8AuAr-4e2dpB`f:',
                        inputs: {COSTUME: [1, 'vAeeUYBd-,0D:?rqZkET']},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    'vAeeUYBd-,0D:?rqZkET': {
                        opcode: 'looks_costume',
                        next: null,
                        parent: 'RTP9jg7#y!9N?XpfL4x]',
                        inputs: {},
                        fields: {COSTUME: ['Mr Hien 5', null]},
                        shadow: true,
                        topLevel: false
                    },
                    'P:z0EWXP,l}Ao]PvZmVz': {
                        opcode: 'looks_switchcostumeto',
                        next: '03[9;CHse_kof}!{mBE!',
                        parent: 'e584j?h$!clIad4mBE7{',
                        inputs: {COSTUME: [1, '#]CuKsa#PI)N2|pU#V2+']},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    '#]CuKsa#PI)N2|pU#V2+': {
                        opcode: 'looks_costume',
                        next: null,
                        parent: 'P:z0EWXP,l}Ao]PvZmVz',
                        inputs: {},
                        fields: {COSTUME: ['Mr Hien 2', null]},
                        shadow: true,
                        topLevel: false
                    },
                    '^!Sf-X#B:1*C(!5foAq?': {
                        opcode: 'looks_switchcostumeto',
                        next: '#^zGMJEGZw(m*Ek!R$-n',
                        parent: '03[9;CHse_kof}!{mBE!',
                        inputs: {COSTUME: [1, '|*+geu!~sbW=:;l7[d-;']},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    '|*+geu!~sbW=:;l7[d-;': {
                        opcode: 'looks_costume',
                        next: null,
                        parent: '^!Sf-X#B:1*C(!5foAq?',
                        inputs: {},
                        fields: {COSTUME: ['Mr Hien 3', null]},
                        shadow: true,
                        topLevel: false
                    },
                    '#^zGMJEGZw(m*Ek!R$-n': {
                        opcode: 'looks_sayforsecs',
                        next: '/PhEg39@uxxV6N9hOO|y',
                        parent: '^!Sf-X#B:1*C(!5foAq?',
                        inputs: {MESSAGE: [1, [10, 'Sau khóa học này các em có thể tạo ra các đoạn phim ngắn']], SECS: [1, [4, '4']]},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    '/PhEg39@uxxV6N9hOO|y': {
                        opcode: 'looks_switchcostumeto',
                        next: 'l9e=WeLPi!Lks2H]]$xv',
                        parent: '#^zGMJEGZw(m*Ek!R$-n',
                        inputs: {COSTUME: [1, '-omG=(^,mN5xbuXyHB1c']},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    '-omG=(^,mN5xbuXyHB1c': {
                        opcode: 'looks_costume',
                        next: null,
                        parent: '/PhEg39@uxxV6N9hOO|y',
                        inputs: {},
                        fields: {COSTUME: ['Mr Hien 4', null]},
                        shadow: true,
                        topLevel: false
                    },
                    'l9e=WeLPi!Lks2H]]$xv': {
                        opcode: 'looks_sayforsecs',
                        next: 'PZsiBWf/QaH_3(~Rd/FR',
                        parent: '/PhEg39@uxxV6N9hOO|y',
                        inputs: {MESSAGE: [1, [10, 'Hoặc là các trò chơi đơn giản']], SECS: [1, [4, '4']]},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    'PZsiBWf/QaH_3(~Rd/FR': {
                        opcode: 'looks_switchcostumeto',
                        next: 'wcXz=23qzWcf0$|.0|Sh',
                        parent: 'l9e=WeLPi!Lks2H]]$xv',
                        inputs: {COSTUME: [1, 'XbnLg/c)%}~G|H.J._n|']},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    },
                    'XbnLg/c)%}~G|H.J._n|': {
                        opcode: 'looks_costume',
                        next: null,
                        parent: 'PZsiBWf/QaH_3(~Rd/FR',
                        inputs: {},
                        fields: {COSTUME: ['Mr Hien 2', null]},
                        shadow: true,
                        topLevel: false
                    },
                    'wcXz=23qzWcf0$|.0|Sh': {
                        opcode: 'looks_sayforsecs',
                        next: null,
                        parent: 'PZsiBWf/QaH_3(~Rd/FR',
                        inputs: {MESSAGE: [1, [10, 'Cùng khám phá thôi nàooooo!']], SECS: [1, [4, '4']]},
                        fields: {},
                        shadow: false,
                        topLevel: false
                    }
                },
                currentCostume: 0,
                costumes: [
                    {
                        assetId: '9d2b256728417f57326ed57b64f7630b',
                        name: 'Mr Hien 0',
                        bitmapResolution: 2,
                        md5ext: '9d2b256728417f57326ed57b64f7630b.png',
                        dataFormat: 'png',
                        rotationCenterX: 100,
                        rotationCenterY: 360
                    },
                    {
                        assetId: '72c5d407857b80713db8866cc4800907',
                        name: 'Mr Hien 1',
                        bitmapResolution: 2,
                        md5ext: '72c5d407857b80713db8866cc4800907.png',
                        dataFormat: 'png',
                        rotationCenterX: 87,
                        rotationCenterY: 291
                    },
                    {
                        assetId: 'd3143ea5f5a92a60b395b41d9d3962ca',
                        name: 'Mr Hien 2',
                        bitmapResolution: 2,
                        md5ext: 'd3143ea5f5a92a60b395b41d9d3962ca.png',
                        dataFormat: 'png',
                        rotationCenterX: 88,
                        rotationCenterY: 292
                    },
                    {
                        assetId: 'd95d61950df469a156d08e1567cc3ff4',
                        name: 'Mr Hien 3',
                        bitmapResolution: 2,
                        md5ext: 'd95d61950df469a156d08e1567cc3ff4.png',
                        dataFormat: 'png',
                        rotationCenterX: 165,
                        rotationCenterY: 292
                    },
                    {
                        assetId: '2b14d11e67b245134e4c8401414262a9',
                        name: 'Mr Hien 4',
                        bitmapResolution: 2,
                        md5ext: '2b14d11e67b245134e4c8401414262a9.png',
                        dataFormat: 'png',
                        rotationCenterX: 96,
                        rotationCenterY: 291
                    },
                    {
                        assetId: 'ec6c51344446b92e4fc1fb490c56c3ed',
                        name: 'Mr Hien 5',
                        bitmapResolution: 2,
                        md5ext: 'ec6c51344446b92e4fc1fb490c56c3ed.png',
                        dataFormat: 'png',
                        rotationCenterX: 165,
                        rotationCenterY: 310
                    }
                ],
                sounds: [],
                volume: 100,
                visible: true,
                x: 0,
                y: -30,
                size: 90,
                direction: 90,
                draggable: false,
                rotationStyle: 'all around'
            }
        ],
        meta: {
            semver: '3.0.0',
            vm: '0.1.0',
            agent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_13_3) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/65.0.3325.181 Safari/537.36' // eslint-disable-line @stylistic/max-len
        }
    });
};


export default projectData;
